// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__1rRow","content":"Consent_content__u7wgJ","footer":"Consent_footer__7Yp5o"};